import React, { useRef } from 'react';
import { XIcon, DownloadIcon } from 'lucide-react';
import jsPDF from 'jspdf';
interface ResumeModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
}
const ResumeModal = ({
  isOpen,
  onClose,
  imageUrl
}: ResumeModalProps) => {
  const imageRef = useRef<HTMLImageElement>(null);
  if (!isOpen) return null;
  const handleDownloadPDF = async () => {
    try {
      // Create a new jsPDF instance
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      // Load the image
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = imageUrl;
      img.onload = () => {
        // Get PDF dimensions
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        // Calculate image dimensions to fit PDF page
        const imgWidth = img.width;
        const imgHeight = img.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const width = imgWidth * ratio;
        const height = imgHeight * ratio;
        // Center the image on the page
        const x = (pdfWidth - width) / 2;
        const y = (pdfHeight - height) / 2;
        // Add image to PDF
        pdf.addImage(img, 'JPEG', x, y, width, height);
        // Save the PDF
        pdf.save('Bhavini_Sapra_Resume.pdf');
      };
      img.onerror = () => {
        console.error('Failed to load image for PDF conversion');
        alert('Failed to download resume. Please try again.');
      };
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Failed to download resume. Please try again.');
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" onClick={onClose} data-id="element-166">
      <div className="relative bg-gray-900 rounded-lg shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden border border-gray-700" onClick={e => e.stopPropagation()} data-id="element-167">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 rounded-full bg-gray-800 hover:bg-gray-700 text-gray-300 hover:text-white transition-colors" aria-label="Close modal" data-id="element-168">
          <XIcon className="h-6 w-6" data-id="element-169" />
        </button>

        {/* Download link */}
        <div className="bg-gray-800 px-6 py-4 border-b border-gray-700" data-id="element-170">
          <button onClick={handleDownloadPDF} className="inline-flex items-center text-indigo-400 hover:text-indigo-300 font-medium transition-colors" data-id="element-171">
            <DownloadIcon className="h-4 w-4 mr-2" data-id="element-172" />
            Click to download file
          </button>
        </div>

        {/* Resume image */}
        <div className="overflow-auto max-h-[calc(90vh-80px)] bg-gray-800 p-6" data-id="element-173">
          <img ref={imageRef} src={imageUrl} alt="Bhavini Sapra Resume" className="w-full h-auto rounded-lg shadow-lg" data-id="element-174" />
        </div>
      </div>
    </div>;
};
export default ResumeModal;